<template>
  <v-snackbar
    v-model="show"
    :timeout="snackbar.timeout"
    :top="snackbar.position.top"
    :bottom="snackbar.position.bottom"
    :right="snackbar.position.right"
    :left="snackbar.position.left"
    :multi-line="isMultiLine"
    :style="{'z-index': 400}"
  >
    {{ translation }}
    <v-btn flat color="primary" @click.native="show = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    snackbar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    isMultiLine() {
      let result = false;

      if ((this.$vuetify.breakpoint.mdAndUp && this.translation.length >= 66)
         || (this.$vuetify.breakpoint.sm && this.translation.length >= 24)
         || (this.$vuetify.breakpoint.xs && this.translation.length >= 58)) {
        result = true;
      }

      return result;
    },
    translation() {
      return this.$t(this.snackbar.message, this.snackbar.messageParams);
    },
  },
  watch: {
    snackbar() {
      this.show = true;
    },
  },
};
</script>
